<template>
  <v-form ref="roleForm">
    <v-text-field
      v-model="data.Nomb"
      :rules="rules.name"
      label="Nombre"
      outlined
      dense
      required
    ></v-text-field>

    <v-row>
      <v-col cols="2">
        <v-switch v-model="data.Actv" label="Activo"></v-switch>
      </v-col>
    </v-row>
    <PermisosTable
      ref="permisos"
      :type="'Cards'"
      :edit="true"
      :rolsData="data.rolsData"
      :patchData="data.patchData"
    ></PermisosTable>

    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import PermisosTable from "../MainComponents/PermisosTable.vue";
import Permisos from "../../clases/Permisos.js";
const userPermissions = new Permisos("Admin");
export default {
  name: "CajerosForm",
  components: { PermisosTable },
  props: ["edit", "dataEdit"],
  data() {
    return {
      data: {
        Actv: false,
        Nomb: null,
        rolsData: userPermissions.roleBlock,
        patchData: userPermissions.patch,
      },
      rules: {
        name: [(value) => !!value || "El email es obligatorio"],
        department: [(value) => !!value || "El departamento es obligatorio"],
      },
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.roleForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.data;
      const departments = {};
      this.data.Dpts.forEach((department) => (departments[department] = true));
      dataSave.Dpts = departments;

      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.Id;
      }

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    this.data.Dpto = "ProShop"; //localStorage.getItem("selectedDepartment");

    if (this.edit) {
      const departments = [];
      Object.keys(this.dataEdit.Dpts).forEach((department) =>
        departments.push(department)
      );

      (this.data.Actv = this.dataEdit.Actv),
        (this.data.Dpts = departments),
        (this.data.Nomb = this.dataEdit.Nomb);
    }
  },
};
</script>
